import { forwardRef } from 'react';
import { cx } from 'class-variance-authority';
import { Box } from '../Box';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';

import * as styles from './styles';
import { HeadingNumber } from '../HeadingNumber';
import { Typography } from '../Typography';

type StepsItemTypeMap = BaseTypeMap<
  'li',
  { nr: number; active?: boolean; completed?: boolean }
>;

export type StepsItemProps = ComponentProps<StepsItemTypeMap>;

export const StepsItem: Component<StepsItemTypeMap> = forwardRef(
  function StepsItem(
    { children, className, nr, active, completed, ...rest },
    ref
  ) {
    return (
      <Box
        as="li"
        className={cx(styles.item({ active }), className)}
        ref={ref}
        {...rest}
      >
        <HeadingNumber
          color={!!active ? 'primary' : 'neutral'}
          dimmed={!active}
          size="sm"
        >
          {!completed ? (
            nr
          ) : (
            // TODO: Move to icon lib
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <mask
                id="mask0_6657_67015"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" />
              </mask>
              <g mask="url(#mask0_6657_67015)">
                <path d="M9.54988 17.575C9.41655 17.575 9.29155 17.554 9.17488 17.512C9.05821 17.4707 8.94988 17.4 8.84988 17.3L4.54988 13C4.36655 12.8167 4.27888 12.579 4.28688 12.287C4.29555 11.9957 4.39154 11.7584 4.57488 11.575C4.75821 11.3917 4.99155 11.3 5.27488 11.3C5.55821 11.3 5.79155 11.3917 5.97488 11.575L9.54988 15.15L18.0249 6.67502C18.2082 6.49169 18.4459 6.40002 18.7379 6.40002C19.0292 6.40002 19.2665 6.49169 19.4499 6.67502C19.6332 6.85836 19.7249 7.09569 19.7249 7.38702C19.7249 7.67902 19.6332 7.91669 19.4499 8.10002L10.2499 17.3C10.1499 17.4 10.0415 17.4707 9.92488 17.512C9.80821 17.554 9.68321 17.575 9.54988 17.575Z" />
              </g>
            </svg>
          )}
        </HeadingNumber>
        <Typography intent="title" size="sm">
          {children}
        </Typography>
      </Box>
    );
  }
);
